export const APPSTORE_URL =
  'https://apps.apple.com/ca/app/velocity-manager/id6714478634'
export const PLAYSTORE_URL =
  'https://play.google.com/store/apps/details?id=com.velocitymgr&pcampaignid=web_share'
export const ADMIN = ['System Administrator', 'Super Admin']
export const SUPER_ADMIN = 'Super Admin'
export const SAMPLE_UPLOAD_FILE_LINKS: Record<string, string> = {
  locations:
    'http://res.cloudinary.com/tobilasinde/raw/upload/v1737502029/schedule/development/B0001/import/locations/mc8lffvjgmpxi122fgcd.csv',
  services:
    'http://res.cloudinary.com/tobilasinde/raw/upload/v1737506131/schedule/development/B0001/import/services/eudmhqbleczffxdcfhc6.csv'
}
export const deductionAvailCountries = ['Canada', 'Nigeria']
export const defaultLogo = process.env.PUBLIC_URL + '/assets/logo/logo.png'
export const colors = {
  primary: '#008080',
  secondary: '#95E4CF',
  tertiary: '#FAD291'
}
